import { Injectable } from '@angular/core';
import { CometChat } from './cometchat-sdk';
import { ChatStore } from '../state/chat.store';
import { CometChatInitService } from './cometchat-init.service';

@Injectable({ providedIn: 'root' })
export class CometChatAuthService {

  constructor(
    private initService: CometChatInitService,
    private store: ChatStore,
  ) {}

  async loginWithToken(authToken: string): Promise<any> {
    await this.initService.init();

    const alreadyLogged = await CometChat.getLoggedinUser();
    if (alreadyLogged) {
      await CometChat.logout();
    }

    const user = await CometChat.login(authToken);
    this.store.setSdkReady(true);
    return user;
  }

  async logout(): Promise<void> {
    await CometChat.logout();
    this.store.setSdkReady(false);
  }

  async currentUid(): Promise<string | null> {
    const user = await CometChat.getLoggedinUser();
    return user?.getUid() ?? null;
  }
}
